import React from "react";
import { MapPin, ExternalLink } from "lucide-react";

/**
 * Small embedded map for an address using Google Maps free embed (no API key)
 * plus an "Open in maps" button that goes to Google Maps.
 */
export default function AddressMap({ customer, height = 180, compact = false }) {
  const parts = [customer?.address, customer?.zip_code, customer?.city, customer?.province].filter(Boolean);
  if (!parts.length) return null;
  const query = parts.join(", ");
  const encoded = encodeURIComponent(query);
  const embed = `https://maps.google.com/maps?q=${encoded}&t=&z=16&ie=UTF8&iwloc=&output=embed`;
  const open = `https://www.google.com/maps/search/?api=1&query=${encoded}`;
  return (
    <div className="rounded-xl overflow-hidden border border-zinc-800 bg-zinc-950" data-testid="address-map">
      <iframe
        title={`Mappa ${customer?.name || ""}`}
        src={embed}
        width="100%"
        height={height}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        style={{ border: 0, display: "block" }}
      />
      <div className="flex items-center justify-between p-2 border-t border-zinc-900 gap-2">
        <div className="flex items-center gap-2 text-xs min-w-0">
          <MapPin className="h-3.5 w-3.5 text-red-300 shrink-0" />
          <span className="truncate">{query}</span>
        </div>
        {!compact && (
          <a
            href={open}
            target="_blank"
            rel="noreferrer"
            className="pill pill-red text-[10px] shrink-0 hover:opacity-90"
            data-testid="address-map-open"
          >
            <ExternalLink className="h-3 w-3" /> Apri in Maps
          </a>
        )}
      </div>
    </div>
  );
}
